import { useState, useCallback } from "react";

// G2 — Kolon başlığına tıklayınca sıralama (A→Z / Z→A, küçük→büyük, tarih).
// Türkçe-duyarlı, sayısal ve tarih değerlerini akıllı karşılaştırır.
export function useSort(defaultKey = null, defaultDir = "asc") {
  const [sort, setSort] = useState({ key: defaultKey, dir: defaultDir });

  // Tek atomik güncelleme — React StrictMode updater'ı iki kez çağırdığında
  // (idempotent olduğu için) toggle iki kez tersine dönüp iptal olmaz.
  const toggle = useCallback((key) => {
    setSort((s) =>
      s.key === key
        ? { key, dir: s.dir === "asc" ? "desc" : "asc" }
        : { key, dir: "asc" }
    );
  }, []);

  const { key: sortKey, dir: sortDir } = sort;

  const sortRows = useCallback((rows, accessors) => {
    if (!sortKey || !accessors || !accessors[sortKey]) return rows;
    const acc = accessors[sortKey];
    const arr = [...rows];
    arr.sort((a, b) => {
      let va = acc(a);
      let vb = acc(b);
      if (va == null) va = "";
      if (vb == null) vb = "";
      let cmp;
      if (typeof va === "number" && typeof vb === "number") cmp = va - vb;
      else cmp = String(va).localeCompare(String(vb), "tr", { numeric: true, sensitivity: "base" });
      return sortDir === "asc" ? cmp : -cmp;
    });
    return arr;
  }, [sortKey, sortDir]);

  return { sortKey, sortDir, toggle, sortRows };
}
